var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-blue",on:{"click":_vm.toggle}},[_c('span',{staticClass:"fa text-lg m-1",class:_vm.classObject}),_c('span',[_vm._v(" "+_vm._s(_vm.setting.displayName)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }